import type { UTXO } from '../../WaasBitcoinWalletProvider.types';

/**
 * Calculates the total value of UTXOs
 *
 * @param utxos - Array of UTXOs
 * @returns Total value in satoshis
 */
export const calculateUTXOTotal = (utxos: UTXO[]): number =>
  utxos.reduce((total: number, utxo: UTXO) => total + utxo.value, 0);
